import type { IChallenge } from "@bbj-types/challenge";
import { useMemo } from "react";

export const useChallengesByTags = (challenges: IChallenge[], tags?: string[]) => {
  return useMemo(
    () => challenges.filter((challenge) => tags?.some((tag) => challenge.tags.includes(tag))),
    [challenges, tags]
  );
};
